import { useTranslation } from 'react-i18next';
import {
  Tooltip, TooltipContent, TooltipProvider, TooltipTrigger,
} from '@repo/ui/src/components/ui/tooltip';

/** Wraps a disabled trigger so hover still shows the RBAC "admins only" tooltip
 * (disabled elements don't fire pointer events, so the tooltip needs a wrapping
 * span). When `show` is false the children render untouched — no Tooltip
 * overhead for admins/owners. `className` lands on the wrapper span so layout
 * hooks like `ml-auto` survive the wrapping. */
export function AdminOnlyTooltip({
  show, className, reason, children,
}: {
  show: boolean;
  className?: string;
  /** Overrides the default "admins only" text — e.g. when PageHeader passes an
   *  action's own `disabledReason` through. */
  reason?: string;
  children: React.ReactNode;
}) {
  const { t } = useTranslation('common');
  if (!show) return <>{children}</>;
  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span tabIndex={0} className={className}>{children}</span>
        </TooltipTrigger>
        <TooltipContent>{reason ?? t('rbac.adminOnly')}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
